import { useMediaQuery } from '@mui/material'
import gaiaTheme from '../../../../root-components/theme';
import { TableDisplay } from '../../../presentation-components/miscellaneous-components/table-display';
import { IHeadCell } from '../../../../shared/interfaces/table-display.model';
import ReportPeriodService from '../../../../shared/services/report-period/report-period.service';
import { IReportPeriod } from '../../../../shared/services/report-period/report-period.model';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingPage } from '../../loading-page';
import { UserDetailsContext } from '../../../../context/user-details/user-details';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';

export const ReportingEsrsPage = () => {

  const navigate = useNavigate();
  const reportPeriodService = new ReportPeriodService();
  const userNotificationsContext = useContext(UserNotificationsContext)
  const userDetailsContext = useContext(UserDetailsContext)
  const userDetails = userDetailsContext.userDetails
  const [reportPeriods, setReportPeriods] = useState<IReportPeriod[]>();
  const [selected, setSelected] = useState<string[]>([]);
  const [inputPage, setInputPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const companyName = (!userDetails?.isPartner && userDetails?.partnerOrganisation) || (userDetails?.isPartner && userDetails?.isLoggedInAsClient) ? userDetails?.partnerOrganisation?.partnerName : 'Gaia';

  useEffect(() => {
    reportPeriodService.getAllReportPeriodsWithReportDetailsPagination(`includeEsrs=true`, inputPage, perPage)
      .then(response => {
        setIsLoading(false)
        setReportPeriods(response.rows)
        setTotalRecords(response.count);
      })
      .catch(err => console.log(err))
  }, [inputPage, perPage])

  const headCells: IHeadCell[] = [
    { id: 'reportPeriod', numeric: false, label: 'Report Period', sortable: false, isHeading: true },
    { id: 'markedAsCompleted', numeric: false, label: 'Status', sortable: false, isSubHeading: true },
  ];


  const rows = !reportPeriods ? [] : reportPeriods?.map(reportPeriod => {
    return {
      id: reportPeriod.id,
      reportPeriod: reportPeriod.friendlyName,
    }
  });

  const handleSelected = (selectedRowId: string[]) => {
    if (!userDetails?.organisation.subscriptionActive || (userDetails.organisation.subscriptionActive && userDetails.organisation.freeTrialDaysRemaining && userDetails.organisation.freeTrialDaysRemaining > 0)) {
      userNotificationsContext.openDialog({ active: true, hideCancelButton: true, title: 'Access Denied', message: `You must have a subscription to ${companyName} Carbon Accounting to be able to view your ESRS Report.`, buttonCopy: 'Ok', })
    } else {
      if (selectedRowId[0] !== undefined) {
        // navigate(`/reporting/european-sustainability-reporting-standard/${selectedRowId[0]}`)
        navigate(`/reporting/european-sustainability-reporting-standard/${selectedRowId[0]}/e1-6`)
      }
    }
  }

  return (
    <PageOuterContainer>
      <PageHeading
        title='European Sustainability Reporting Standard (ESRS) E1 - Climate Action'
        includeBackButton={true}
        backButtonLink='/reporting'
        backButtonText='Back to reporting'
      />
      <LoadingPage pageReady={!isLoading}>
        {reportPeriods &&
          <TableDisplay
            isMobileMode={isMobileMode}
            headCells={headCells}
            rows={rows}
            handleSelected={handleSelected}
            selected={selected}
            setSelected={setSelected}
            inputPage={inputPage}
            setInputPage={setInputPage}
            totalRecords={totalRecords}
            perPage={perPage}
            setPerPage={setPerPage} />
        }
      </LoadingPage>
    </PageOuterContainer>
  )
}